class AlternativeApiClient {
  BASE_URL = 'https://external-web-proxy.coinledger.io/api.alternative.me';

  async getFearAndGreedIndexData() {
    const url = new URL(this.BASE_URL + "/fng/");
    url.searchParams.set('limit', '365');

    const res = await fetch(url);
    let values;

    if (res.ok) {
      const json = await res.json();
      const indexValues = json?.data;
      values = indexValues ? {
        currentValue: indexValues[0].value,
        overviewValues: [
          { label: "Previous close", classification: indexValues[1].value_classification, value: indexValues[1].value },
          { label: "1 week ago", classification: indexValues[7].value_classification, value: indexValues[7].value },
          { label: "1 month ago", classification: indexValues[30].value_classification, value: indexValues[30].value },
          { label: "1 year ago", classification: indexValues[364].value_classification, value: indexValues[364].value }
        ]
      } : null
    }

    return {
      values: values,
      error: values ? null : res.statusText
    }
  }

  async getBitcoinSummaryInfo(currency) {
    const url = new URL(`${this.BASE_URL}/v1/global`);
    url.searchParams.set('convert', currency.toUpperCase());

    const res = await fetch(url);
    
    let summaryValues;
    if (res.ok) {
      const json = await res.json();

      const marketCapKey = `total_market_cap_${currency}`;
      const dailyVolumeKey = `total_24h_volume_${currency}`;
      const dominanceKey = "bitcoin_percentage_of_market_cap";

      summaryValues = {
        marketCap: json[marketCapKey],
        dailyVolume: json[dailyVolumeKey],
        dominance: json[dominanceKey]
      }
    }

    return {
      summaryValues: summaryValues,
      error: summaryValues ? null : res.statusText
    }
  }
}

export default new AlternativeApiClient();
